(function () {
  function getNameInput() {
    return document.querySelector('input[name="properties[Nombre, con cantidad de letras seleccionada]"]');
  }

  function getQtyContainer() {
    return document.querySelector('.option-selector[data-selector-type="dropdown"][data-option="Elige la cantidad de letras"]');
  }

  function getSelectedCount(qtyContainer) {
    if (!qtyContainer) return null;
    const listbox = qtyContainer.querySelector('.custom-select__listbox');
    const selected = listbox && listbox.querySelector('[role="option"][aria-selected="true"]');
    if (selected) {
      const v = parseInt(selected.getAttribute('data-value'), 10);
      if (Number.isFinite(v)) return v;
    }
    const btn = qtyContainer.querySelector('button.custom-select__btn');
    if (btn) {
      const txt = (btn.querySelector('span')?.textContent || btn.textContent || '').trim();
      const n = parseInt(txt, 10);
      if (Number.isFinite(n)) return n;
    }
    return null;
  }

  function applyLimit(nameInput, qtyContainer) {
    const n = getSelectedCount(qtyContainer);
    if (!n || !nameInput) return;
    const pattern = '^[A-Za-z]{' + n + '}$'; // solo A–Z, sin ñ/acentos/espacios

    nameInput.setAttribute('maxlength', n);
    nameInput.setAttribute('minlength', n);
    nameInput.setAttribute('pattern', pattern);

    // Limpia y recorta
    nameInput.value = nameInput.value.replace(/[^A-Za-z]/g, '').slice(0, n);

    let help = nameInput.parentElement.querySelector('.name-limit-help');
    if (!help) {
      help = document.createElement('div');
      help.className = 'name-limit-help';
      help.style.fontSize = '12px';
      help.style.marginTop = '6px';
      help.style.opacity = '0.85';
      nameInput.insertAdjacentElement('afterend', help);
    }
    help.textContent = 'Debe tener exactamente ' + n + ' letras (A–Z, sin ñ).';

    console.log('[letter-limit] aplicado. N =', n);
  }

  function init() {
    const nameInput = getNameInput();
    const qtyContainer = getQtyContainer();

    console.log('[letter-limit] init',
      { foundInput: !!nameInput, foundQty: !!qtyContainer });

    if (!nameInput || !qtyContainer) return;

    // Filtra al escribir
    nameInput.addEventListener('input', function () {
      const n = getSelectedCount(qtyContainer);
      if (!n) return;
      let v = nameInput.value.replace(/[^A-Za-z]/g, '');
      if (v.length > n) v = v.slice(0, n);
      if (v !== nameInput.value) nameInput.value = v;
    });

    // Reacciona a cambios del custom select
    qtyContainer.addEventListener('click', function (e) {
      const opt = e.target.closest('.custom-select__option[role="option"]');
      if (opt) setTimeout(() => applyLimit(nameInput, qtyContainer), 0);
    });

    // Observa cambios de aria-selected y de texto del botón
    const listbox = qtyContainer.querySelector('.custom-select__listbox');
    if (listbox) {
      new MutationObserver(() => applyLimit(nameInput, qtyContainer))
        .observe(listbox, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    }
    const btn = qtyContainer.querySelector('button.custom-select__btn');
    if (btn) {
      const span = btn.querySelector('span') || btn;
      new MutationObserver(() => applyLimit(nameInput, qtyContainer))
        .observe(span, { childList: true, characterData: true, subtree: true });
    }

    // Validación al enviar (cubre atajos)
    document.addEventListener('submit', function (e) {
      const n = getSelectedCount(qtyContainer);
      if (!n || !nameInput) return;
      const re = new RegExp('^[A-Za-z]{' + n + '}$');
      if (!re.test(nameInput.value)) {
        e.preventDefault();
        nameInput.focus();
        try { nameInput.reportValidity && nameInput.reportValidity(); } catch (_) {}
        alert('El texto debe tener exactamente ' + n + ' letras (A–Z, sin ñ).');
      }
    }, true);

    // Primera aplicación
    applyLimit(nameInput, qtyContainer);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
